// extracted by mini-css-extract-plugin
module.exports = {"errors":"MultiSelect-module__errors___1Np4q","extra":"MultiSelect-module__extra___1xNSS"};